import { universalWrapRootElement } from "./root-wrapper";
import "./src/style-overrides/search.css";

export const wrapRootElement = universalWrapRootElement;
